import apiService from '@/state/services/Api'

const measuringPoints = {
  namespaced: true,
  state: {
    cached: [],
  },
  getters: {},
  mutations: {},
  actions: {
    get({state, commit}) {
      return apiService
        .query(`measuring_points/`)
        .then(data => {
          return data
        })
        .catch(err => {
          console.warn(err)
        })
    },

    create({state, commit}, body) {
      return apiService.post(`measuring_points/`, body).then(data => {
        return data
      })
    },

    update({state, commit}, {id, body}) {
      return apiService.patch(`measuring_points/${id}/`, body).then(data => {
        return data
      })
    },
  },
}

export default measuringPoints
